import { useNavbar } from "../../hooks";
import styles from "./navbar-search-tablet-modal.module.css";

export type NavbarSearchTabletModal = {
  isOpen: boolean;
  onClose: () => void;
};

export function NavbarSearchTabletModal({
  isOpen,
  onClose,
}: NavbarSearchTabletModal) {
  const { renderAutocomplete } = useNavbar();

  return (
    <div className={styles.Container} data-open={isOpen}>
      <div className={styles.Content}>
        {renderAutocomplete?.({ isTablet: true })}
        <button type="button" className={styles.Button} onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
